import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, EMPTY, Observable } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

// notifications come from the QuickBooks app, the broker api only forwards them
@Injectable({
  providedIn: 'root'
})
export class QuickbookNotificationService {
  private unreadCount = new BehaviorSubject<number>(0);
  private lastRefresh = 0;
  private readonly REFRESH_COOLDOWN_MS = 15000;
  private readonly url = urls.API_URL + urls.QUICKBOOK + '/' + urls.NOTIFICATIONS_URL;

  constructor(private http: HttpClient) { }

  getUnreadCount(): Observable<number> {
    return this.unreadCount.asObservable();
  }

  setUnreadCount(count: number) {
    this.unreadCount.next(Math.max(0, count || 0));
  }

  decrementUnreadCount(amount = 1) {
    this.setUnreadCount(this.unreadCount.getValue() - amount);
  }

  // every call logs in to the QuickBooks app, so the header does not ask more than once per cooldown
  refreshUnreadCount(force = false) {
    const now = Date.now();
    if (!force && now - this.lastRefresh < this.REFRESH_COOLDOWN_MS) {
      return;
    }
    this.lastRefresh = now;
    this.http.get<{ count: number }>(this.url + '/unread-count')
      // the bell is only a badge, a failure must not toast on every window focus
      .pipe(catchError(() => EMPTY))
      .subscribe(data => this.setUnreadCount(data?.count));
  }

  getNotifications(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(this.url, { params }).pipe(catchError(errorHandl));
  }

  markAsRead(id: string): Observable<any> {
    return this.http.patch(this.url + `/${id}`, { isRead: true }).pipe(catchError(errorHandl));
  }

  markAllAsRead(): Observable<any> {
    return this.http.patch(this.url + '/mark-all-read', {}).pipe(catchError(errorHandl));
  }
}
